import { render, staticRenderFns } from "./NFCBackgroundListener.vue?vue&type=template&id=4648cee6&scoped=true"
import script from "./NFCBackgroundListener.vue?vue&type=script&lang=js"
export * from "./NFCBackgroundListener.vue?vue&type=script&lang=js"
import style0 from "./NFCBackgroundListener.vue?vue&type=style&index=0&id=4648cee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648cee6",
  null
  
)

export default component.exports